import { NgTemplateOutlet } from '@angular/common';
import {
  Component,
  ContentChild,
  TemplateRef,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';

import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'rt-add-line',
  templateUrl: 'add-line.component.html',
  styleUrls: ['./add-line.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IconComponent, NgTemplateOutlet],
})
export class AddLineComponent {
  @ContentChild(TemplateRef, { static: true })
  public set onTemplateRef(templateRef: TemplateRef<any>) {
    this.iconTemplate = templateRef;
  }

  public readonly disabled = input<boolean>(undefined!);
  public iconTemplate: TemplateRef<any>;
}
